import { PurchaseOrderStatus as S } from "../types";

/** Satın alma ekranının ortak yardımcıları (liste, çekmece, sipariş modalı, seçiciler). */
export const PO_STATUS_LABEL: Record<S, string> = {
  [S.Draft]: "Taslak",
  [S.Ordered]: "İletildi",
  [S.PartiallyReceived]: "Kısmen alındı",
  [S.Received]: "Tamamlandı",
  [S.Cancelled]: "İptal",
};

/** Yalnız tarih kısmı ayrıştırılır (toISOString yok): "2026-09-12T00:00:00" → yerel gece yarısı. */
export const poDate = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};
export const poFmtDate = (iso?: string | null) =>
  iso ? poDate(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—";
export const poFmtQty = (n: number) => n.toLocaleString("tr-TR", { maximumFractionDigits: 3 });
const NUM_PLAIN = /^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/;     // 1250 · 1250,5 · 1250.5 · 0.125 · ,5
const NUM_TR = /^[1-9]\d{0,2}(?:\.\d{3})+(?:,\d+)?$/;    // 1.250 · 1.250,50 (tr-TR binlik ayraçlı)
/** Sayı girdisi: ekranda gösterilen tr-TR biçimini de okur; geçersizde NaN döner, sessizce kırpmaz ("1.250,50" → 1250.5). */
export const poParse = (s: string): number => {
  const t = (s || "").trim();
  if (NUM_TR.test(t)) return parseFloat(t.replace(/\./g, "").replace(",", "."));
  if (NUM_PLAIN.test(t)) return parseFloat(t.replace(",", "."));
  return NaN;
};
/** Toplam/önizleme için: geçersiz girdi 0 sayılır (doğrulama poParse ile ayrıca yapılır). */
export const poNum = (s: string) => { const n = poParse(s); return isNaN(n) ? 0 : n; };
/** Girdiye yazılan makine değeri ondalığı virgülle taşır; "1.255" binlik sanılıp 1255 okunmasın. */
export const poInput = (n: number) => String(n).replace(".", ",");
/** API hataları düz metin (BadRequest("…")) ya da { detail | title | message } gelir. */
export const poErr = (e: any, fallback: string): string => {
  const d = e?.response?.data;
  if (typeof d === "string" && d.trim()) return d;
  // Çerçevenin İngilizce varsayılanları (çıplak NotFound(), model doğrulama) kullanıcıya gösterilmez
  if (e?.response?.status === 404) return "Kayıt bulunamadı; silinmiş olabilir.";
  if (d?.errors && !d?.detail) return "Gönderilen bilgiler geçersiz; alanları kontrol edin.";
  return d?.detail || d?.title || d?.message || fallback;
};

export const poIsWaiting = (s: S) => s === S.Ordered || s === S.PartiallyReceived;
export const poIsOpen = (s: S) => s === S.Draft || poIsWaiting(s);

export interface PoDue { state: "" | "soon" | "late"; days: number | null; text: string }
/** Beklenen teslim durumu — yalnız sipariş teslim beklerken anlamlıdır. */
export const poDue = (expected: string | null | undefined, status: S): PoDue => {
  if (!expected || !poIsWaiting(status)) return { state: "", days: null, text: "" };
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const days = Math.round((poDate(expected).getTime() - t.getTime()) / 86400000);
  return {
    days,
    state: days < 0 ? "late" : days <= 7 ? "soon" : "",
    text: days < 0 ? `${-days} gün gecikti` : days === 0 ? "bugün" : `${days} gün kaldı`,
  };
};

/** Esc koruması: `self` katmanının üstünde başka bir katman (seçici ya da daha üst modal) varsa true. */
export const poLayerBlocked = (self: HTMLElement | null) => {
  if (document.querySelector(".fp-overlay")) return true;
  const rank = (el: Element) => (el.classList.contains("top") ? 3 : el.classList.contains("center") ? 2 : 1);
  return !!self && Array.from(document.querySelectorAll(".po-overlay")).some((o) => o !== self && rank(o) > rank(self));
};
